import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { selectUserToken } from "features/auth/authSlice";

const useDownloadFile = () => {
  const token = useSelector(selectUserToken);

  const download = useCallback(
    async (url: string, fileName: string) => {

      if (!token) {
        console.error("Token não disponível");
        return;
      }

      const finalUrl = `${process.env.REACT_APP_API_URL}/api${url}`;

      try {
        const response: AxiosResponse<Blob> = await axios({
          method: "GET",
          url: finalUrl,
          responseType: "blob",
          headers: {
            Token: token,
          },
        });

        if (!response.data) {
          console.error("Arquivo vazio");
          return;
        }

        const href = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      } catch (ex: any) {
        console.error("Não foi possível baixar o arquivo:", ex?.message || ex);
      }
    },
    [token]
  );

  return download;
};

export default useDownloadFile;